const FormTypes = {
  MERGE_LOAN: 'mergeLoan',
  LOAN_CALCULATOR: 'loanCalculator',
  MORTGAGE_LOAN: 'mortgageLoan',
  LEAD_FORM: 'lead',
  NEW_FORM: 'newForm',
};

export default FormTypes;
